<script lang="ts" setup>
import Slide from './components/sliders/index.vue'
import Brain from './components/brain/index.vue'
import Industry from './components/industry/index.vue'
</script>

<template>
  <div>
    <Slide />
    <Brain />
    <Industry />
  </div>
</template>

<style scoped></style>
